import { StrictMode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from '@/redux/store';
import Router from '@/app/router';

interface AppProps {
  basename?: string;
}

export function App({ basename }: AppProps) {
  return (
    <StrictMode>
      <Provider store={store}>
        <BrowserRouter basename={basename}>
          <Router />
        </BrowserRouter>
      </Provider>
    </StrictMode>
  );
}
